import { createActions, createHandler, createReducer } from "lib/store";

type State = ReturnType<typeof createInitialState>;

const SET_ALBUM_TRACK_SEARCH_COLUMN = Symbol("AlbumTrack::SearchColumn::Set");

export const AlbumTrackActions = createActions({
  setAlbumTrackSearchColumn(column: string) {
    return { type: SET_ALBUM_TRACK_SEARCH_COLUMN, column };
  }
});

const handler = createHandler<State>({
  [SET_ALBUM_TRACK_SEARCH_COLUMN](state, payload: { column: string }) {
    state.column = payload.column;
  }
});

const createInitialState = () => ({
  column: "제목" as string
});

export const reducer = createReducer(handler, createInitialState);
